import angular from 'angular';

import FormSubmitModule from './form-submit';
import AsyncModule from './async';
import CustomErrorModule from './custom-error';
import CompileComponentModule from './compile-component';
import ScrollContainerModule from './scroll-container';
import ScrollIntoViewModule from './scroll-into-view';
import AutofocusModule from './autofocus';
import BlacklistModule from './blacklist';
import NumberOnlyModule from './number-only';
import OnFocusModule from './on-focus';
import OnBlurModule from './on-blur';
import ProcessKeyModule from './process-key';
import MatchModule from './match';
import CaptureKeysModule from './capture-keys';
import BlurModule from './blur';
import OutsideClickModule from './outside-click';

export default angular
    .module('application.directive', [
        FormSubmitModule.name,
        AsyncModule.name,
        CustomErrorModule.name,
        CompileComponentModule.name,
        ScrollContainerModule.name,
        ScrollIntoViewModule.name,
        AutofocusModule.name,
        BlacklistModule.name,
        NumberOnlyModule.name,
        OnFocusModule.name,
        OnBlurModule.name,
        ProcessKeyModule.name,
        MatchModule.name,
        CaptureKeysModule.name,
        BlurModule.name,
        OutsideClickModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/directive/index.js